import { render, staticRenderFns } from "./ConsentBlocker.vue?vue&type=template&id=b8f95a2e"
import script from "./ConsentBlocker.vue?vue&type=script&lang=ts"
export * from "./ConsentBlocker.vue?vue&type=script&lang=ts"
import style0 from "./ConsentBlocker.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RichText: require('/app/components/base/RichText/RichText.vue').default,ButtonComponent: require('/app/components/base/ButtonComponent/ButtonComponent.vue').default})
